export default "__VITE_ASSET__a1f5f20f__"